import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import JSON translation files
import enTranslation from "./locales/en/translation.json";
import frTranslation from "./locales/fr/translation.json";
import esTranslation from "./locales/es/translation.json";
import ptTranslation from "./locales/pt/translation.json";

// Define the resource object
const resources = {
    en: { translation: enTranslation },
    fr: { translation: frTranslation },
    es: { translation: esTranslation },
    pt: { translation: ptTranslation },
};

i18n.use(initReactI18next).init({
    resources,
    supportedLngs: ["en", "fr", "es", "pt"],
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

export default i18n;
